import { React } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import styled from "styled-components";
import Sidebar from "../../Components/Sidebar/Sidebar";
import { useSession } from "../../authentications/SessionContext";
import Navbar from "../../Components/Navbar/NavBar";
// import { ToastContainer } from "react-toastify"; // Import ToastContainer
// import "react-toastify/dist/ReactToastify.css"; // Import Toastify styles

const MainLayoutOuter = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  height: 100vh;
`;

const MainLayoutInner = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  // border-radius: 25px;
  box-shadow: 0 20px 70px 0 rgba(86, 89, 146, 0.1);
  min-height: 100vh;
  overflow-y: auto;
`;

const MainLayout = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
`;

const SidebarContainer = styled.div`
  margin-left: 15px;
  margin-top: 15px;
  border-right: 1px solid #f3f3f3;
  position: relative;
  min-width: 120px;
  background-color: #fff;
  overflow-y: auto;
  @media (max-width: 768px) {
    display: none;
  }
  &::-webkit-scrollbar {
    width: 1px;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
    border-radius: 12px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #f8f9fa;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #ffefeb;
  }
`;

// const MainLayoutOuter = styled.div`
//   display: flex;
//   justify-content: space-between;
//   flex-direction: row;
//   width: 100%;
//   height: inherit;
//   // overflow-y: scroll;
//   // margin-bottom: 55px;
// `;

const HomePage = () => {
  const { authenticated, sessionInfo } = useSession();
  const { is_suspended, isVTEX } = sessionInfo;
  const location = useLocation();
  const { pathname } = location;
  if (!authenticated) {
    return <Navigate replace to="/signin" />;
  }
  if (typeof is_suspended && is_suspended === true) {
    if (pathname !== "/homepage/subscription") {
      return <Navigate replace to="/homepage/subscription" />;
    }
  }
  if (
    pathname === "homepage" ||
    pathname === "/homepage" ||
    pathname === "/homepage/"
  ) {
    if (isVTEX) {
      return <Navigate to="/homepage/products" />;
    } else {
      return <Navigate to="/homepage/dashboard" />;
    }
  }
  return (
    <MainLayout>
      <MainLayoutOuter className="ss">
        {/* <ToastContainer /> */}
        <SidebarContainer>
          <Sidebar />
        </SidebarContainer>
        <MainLayoutInner>
          <Navbar />
          <Outlet />
        </MainLayoutInner>
      </MainLayoutOuter>
    </MainLayout>
  );
};

export default HomePage;
